import script from "./inquiry-to-use.vue?vue&type=script&lang=ts&setup=true"
export * from "./inquiry-to-use.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__